
const authorityList = [
    //左边导航的数据
    {
        name: "我的信息",
        sysMenuLink:'my_info',
        leftIcon: "icon-gerenzhongxin-zhong-copy",
        height: 0,
        href: "/workbench",
        id: 1
    },
    {
        name: "学员管理",
        sysMenuLink:'my_student',
        leftIcon: "icon-jiaoyu",
        height: 0,
        href: "/studentManage",
        id: 2
    },
    {
        name: "考试管理",
        sysMenuLink:'my_exam',
        leftIcon: "icon-shijuan",
        height: 0,
        href: "/examManage",
        id: 3
    },
    {
        name: "科目管理",
        sysMenuLink:'my_subject',
        leftIcon: "icon-kemu",
        height: 0,
        href: "/subjectManage",
        id: 4
    },
    {
        name: "题库管理",
        sysMenuLink:'my_questions',
        leftIcon: "icon-tiku",
        height: 0,
        href: "/questionManage",
        id: 5
    },
    {
        name: "账户管理",
        sysMenuLink:'my_account',
        leftIcon: "icon-zhanghuguanli",
        height: 0,
        href: "/accountManage",
        id: 6
    },
    {
        name: "我的信息",
        sysMenuLink:'student_info',
        leftIcon: "icon-gerenzhongxin-zhong-copy",
        height: 0,
        href: "/studentInfo",
        id: 7
    },
    {
        name: "我的报考科目",
        sysMenuLink:'student_questions',
        leftIcon: "icon-kemu",
        height: 0,
        href: "/studentSubject",
        id: 8
    }
];
const btnPermission = {
    my_info_logo:false,//机构logo
    my_info_name: false,//机构名称
    my_student_add:false,//录入学员信息
    my_student_edit:false,//编辑学员信息
    my_student_del:false,//删除学员信息
    //my_student_addOrEdit: false,//录入/编辑学员信息
    my_student_pwd:false,//更改学员密码
    my_student_set_time:false,//设置考试时间
    my_student_subject: false,//更改报考科目"
    my_exam_export: false,//导出考试成绩
    my_exam_score:false,//录入实操成绩
    my_subject_addOrEdit:false,//新增/更改科目
    my_subject_delete:false,//删除科目
    my_questions_addOrEdit:false,//新增/编辑试题
    my_questions_delete:false,//删除试题
    my_account_addOrEdit:false,//添加/编辑账号
    my_account_role:false,//管理角色权限
    my_account_delete:false,//删除账号
    
}
export {
    authorityList,
    btnPermission
}



// WEBPACK FOOTER //
// ./src/config/authority.js